import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'replaceText' })
export class ReplaceTextPipe implements PipeTransform {
  transform(value: string, searchValue: string | RegExp, replaceValue: string): string {
    if (typeof value !== 'string') {
      return value;
    }
    return value.replace(searchValue, replaceValue);
  }
}
